import {idListEndpoint, type IdListEndpoint, listEndpoint, type ListEndpoint} from "./util/ListEndpoint"
import type {AxiosInstance} from "axios";
import type {MetlApiExport} from "../metl-models/exports/MetlApiExport.ts";
import type {MetlSharedJobExport} from "../metl-models/exports/MetlSharedJobExport.ts";

export interface SharedJobPackageApi {
    id: string
    jobs: ListEndpoint<SharedJobJobApi, MetlSharedJobExport>
}

export interface SharedJobJobApi {
    id: string
    revisions: IdListEndpoint<SharedJobRevisionApi, MetlSharedJobExport>
}

export interface SharedJobRevisionApi {
    id: string
    export: () => Promise<MetlApiExport<unknown>>
}

export function sharedJobPackageApi(axios: AxiosInstance, baseUrl: string, id: string): SharedJobPackageApi {
    return {
        id,
        jobs: listEndpoint(axios, `${baseUrl}/jobs`, `${id}/jobs`, sharedJobJobApi)
    }
}

function sharedJobJobApi(axios: AxiosInstance, baseUrl: string, id: string): SharedJobJobApi {
    return {
        id,
        revisions: idListEndpoint(axios, `${baseUrl}/revisions`, `${id}/revisions`, sharedJobRevisionApi)
    }
}

function sharedJobRevisionApi(axios: AxiosInstance, baseUrl: string, id: string): SharedJobRevisionApi {
    return {
        id,
        export: async () => {
            const response = await axios.get<MetlApiExport<unknown>>(`${baseUrl}/export`)
            return response.data
        }
    }
}